/*
 * @Author: your name
 * @Date: 2022-04-15 11:36:09
 * @LastEditTime: 2022-05-25 18:39:22
 * @LastEditors: chenyang 1095719816@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \四游项目2\好礼迎五一\js\contraller.js
 */

  /**
   * @description:
   * @param {*} typeOne  类型
   * @param {*} jsonOne  入参
   * @param {*} urlOne   url
   * @return {*}
   */
  function getData(typeOne,jsonOne,urlOne){
    return new Promise((resolve,reject) => {
        let postJson = JSON.stringify({type : typeOne,json:JSON.stringify(jsonOne)});
        $.ajax({
            url:`${urlOne}${postJson}`,
            success(res){
                resolve(res);
            },
            error(error){
              reject(error);
            }
        })

    })
    .then( data =>{
      return { error :null,data}
    })
    .catch(error=>{
        return { error:error ,data:null}
    })
}
var shop_url ='https://shop.09game.com/shop?';
var lottery_u = 'https://ltry.09game.com/lottery?';
var card_url = 'https://ltry.09game.com/pifu?';
var rank_url = 'https://score.09game.com/RPG/IntegralRank';
var UserPub_url ='https://users.09game.com/home/GetUserPub';
var Integration_url ='https://score.09game.com/RPG/Integration';
var pifu_url = 'https://ltry.09game.com/pifu?';
var dota_url ='https://hd.09game.com/daota';
var hd_url ='https://hd.09game.com/box';

// 查询礼包配置
function q_cfg_packet(appId){
    return getData('q_cfg_packet', {app_id:appId} , shop_url)
}
// 相对应的礼包数量
function q_cfg_item(item_id){
    return getData('q_cfg_item', {item_id:item_id} , shop_url)
}
// 查询活动任务
function q_cfg_task(appId){
    return getData('q_cfg_task', {app_id:appId} , shop_url)
}
// 我的任务
function q_my_task(appId,token){
    return getData('q_my_task', {app_id:appId,token:token} , shop_url)
}
// 通行证我的抽奖次数
function q_my_lottery_count(appId,token){
    return getData('q_my_lottery_count', {app_id:appId,token:token} , lottery_u)
}
// 我的礼包
function q_my_packet(appId,token){
    return getData( 'q_my_packet',{app_id:appId,token:token} ,shop_url)
}
// 礼包列表
function q_my_packet_use(appId,token){
    return getData('q_my_packet_use',{app_id:appId,token:token} ,shop_url)
}
// 领取礼包
function use_packet(token,packet_id){
    return getData('use_packet',{ token: token, packet_id: packet_id },shop_url)
}
// 我的道具
function q_my_item(id,token){
    return getData('q_my_item',{ item_id: id, token: token },shop_url)
}
//任务列表
function q_cfg_task(appId,token){
    return getData('q_cfg_task',{app_id:appId,token:token},shop_url)
}

// 抽奖列表
function q_cfg_list(app_id){
    return getData('q_cfg_list',{ app_id: app_id },lottery_u)
}
// 抽奖
function q_single(appId,token,key){
    return getData('single',{ count: 1, key:key, token: token, app_id: appId},lottery_u)
}
// 抽奖记录
function q_my_lottery(appId,token){
    return getData('q_my_lottery',{ token: token, app_id:appId},lottery_u)
}
// 扫码付款
function buy_goods(price,goods_id,token){
    return getData('buy_goods',{price:price,count:1,goods_id:goods_id,TOKEN: token },shop_url)
}
// 查询商品价格信息
 function q_cfg_goods(goodId,token){
     return getData('q_cfg_goods',{ GOODS_ID: goodId, TOKEN: token },shop_url)
 }
//  兑换
 function use_item(dest_id,token,amount){
    return getData('use_item',{ dest_id: dest_id, token: token ,amount:amount},shop_url)
 }
// 取对应券的数量
function q_my_item_amount(token){
    return getData('q_my_item',{ token: token , item_type: 262144,game_type:1},shop_url)
}

// 当天
function isToday(date) {
    var d = new Date(date.toString().replace(/-/g, "/"));
    try {
        var todaysDate = new Date($.ajax({ async: false }).getResponseHeader("Date"));//服务器时间
    } catch (err) {
        var todaysDate = new Date();//客户端时间
    }
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
        return true;
    } else {
        return false;
    }
}
// 抽奖单抽或多抽
function query_lottery(type, json, cb, flag=true) {
    let post = JSON.stringify({ type: type, json: JSON.stringify(json) });
    $.ajax({
        url: `${lottery_u}${post}`,
        async: flag,
        success(res) {
            cb(res);
        }
    })
}

// 排序
function getMaxSort(arr, key) {
    var max = null;
    for (var i = 0; i < arr.length; i++) {
        for (var j = i; j < arr.length; j++) {
            if (key) {
                if (key.indexOf('time') >= 0) {
                    if (Date.parse(arr[i][key].replace(/-/g, "/")) < Date.parse(arr[j][key].replace(/-/g, "/"))) {
                        max = arr[j]
                        arr[j] = arr[i]
                        arr[i] = max
                    }
                } else {
                    if (arr[i][key] < arr[j][key]) {
                        max = arr[j]
                        arr[j] = arr[i]
                        arr[i] = max
                    }
                }
            } else {
                if (arr[i] < arr[j]) {
                    max = arr[j]
                    arr[j] = arr[i]
                    arr[i] = max
                }
            }
        }
    }
    return arr
}


function formatYearMonth(dateString) {
	// 提取年份和月份部分
	var year = dateString.slice(0, 4);
	var month = dateString.slice(4, 6);

	// 拼接年份和月份
	var formattedDate = year + "-" + month;

	return formattedDate;
  }

function isCurrentMonth(today,dateString) {
	var currentDate = new Date(today);
	// var currentDate = new Date("2023-07");
	// console.log('7月份',currentDate);
	var specifiedDate = new Date(dateString);
	// 检查给定日期是否有效
	if (isNaN(specifiedDate.getTime())) {
	  return false; // 无效日期，返回 false
	}
	var currentYear = currentDate.getFullYear();
	var currentMonth = currentDate.getMonth();
	var specifiedYear = specifiedDate.getFullYear();
	var specifiedMonth = specifiedDate.getMonth();
	return currentYear === specifiedYear && currentMonth === specifiedMonth;
  }
function compareTime(startTime, endTime) {
	var start = new Date(startTime.replace("-", "/").replace("-", "/"));
	var end = new Date(endTime.replace("-", "/").replace("-", "/"));
	if (end < start) {
		return false;
	}
	return true;
}
function query_time() {
    let nowTime = null;
    $.ajax({
        url: 'https://webapi.09game.com/Home/GetDateNow',
        async: false,
        success: function (res) {
            if (res.code == 0) {
                var now = res.msg.toString().replace(/-/g, "/");
                nowTime = new Date(now);
            } else {
                nowTime = new Date();
            }
        }
    })
    return nowTime;
}
function GetDateStr(AddDayCount, now) {
	var dd = new Date(now);
	dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
	var y = dd.getFullYear();
	var m = dd.getMonth() + 1; //获取当前月份的日期
	var d = dd.getDate();
	return y + "/" + m + "/" + d;
}

function closeWindow() {
	try {
		window.js_close();
	} catch (error) {
		window.platform.close();
	}
}

//  兑换
const getUserInfo = (token) =>{
  return getData('q_user_info',{ token: token },card_url)
}

const getPacketStatus = (user_id) => {
  return getData('GetPacketStatus',{ user_id: user_id },hd_url)
}

const queryRank = (type, date) => {
  return getData(type,{ date: date },card_url)
}

const queryUserItem = (token, item_type, game_type = 0) => {
  return getData('q_my_item', { token: token, item_type: item_type, game_type: game_type }, shop_url);
}

const queryCfgItem = (item_type, game_type = 0) => {
  return getData('q_cfg_item', { item_type: item_type, game_type: game_type }, shop_url);
}

const queryCfgPacket = (appId) => {
  return getData('q_cfg_packet', { app_id: appId }, shop_url);
}

const queryUserInfo = (token) => {
  return getData('q_user_info', { token: token }, pifu_url)
}
const queryUserExchangeList = (token) => {
  return getData('q_user_exchange_list', { token: token }, pifu_url);
}
const queryPifu = (token) => {
  return getData('q_pifu_list', { token: token }, pifu_url);
}
const queryBoxList = (token) => {
  return getData('q_box_list', { token: token }, pifu_url);
}
const queryBox2List = (token) => {
  return getData('q_box2_list', { token: token }, pifu_url);
}

const getBox1 = (token, count) => {
  return getData('multi', { token: token, count: count , multi_type:1}, pifu_url);
}

const getBox2 = (token, count) => {
  return getData('box', { token: token }, pifu_url);
}

const getBox4 = (token, count) => {
  return getData('box2', { token: token }, pifu_url);
}

const q_user_record = (token, appId) => {
  return getData('q_user_record', { token: token, app_id: appId }, pifu_url);
}

const q_my_money = (token) => {
  return getData('q_my_money', { token: token }, shop_url);
}

const boxStatistics = (token, type, count) => {
  return getData('BoxStatistics', { token: token, type: type, count: count}, hd_url);
}

const query_09game = (url, data, cb, flag = true) => {
  $.ajax({
    url: hd_url + url,
    data: data,
    async: flag,
    success(res) {
      cb(res);
    }
  })
}

export {
    q_cfg_packet,
    q_cfg_item,
    q_cfg_task,
    q_my_task,
    q_my_lottery_count,
    q_my_packet,
    use_packet,
    q_my_packet_use,
    q_my_item,
    q_cfg_list,
    q_single,
    q_my_lottery,
    buy_goods,
    q_cfg_goods,
    use_item,
    q_my_item_amount,
    isToday,
    query_lottery,
    getMaxSort,
    formatYearMonth,
    isCurrentMonth,
    compareTime,
    query_time,
    GetDateStr,
    closeWindow,
    getUserInfo,
    getPacketStatus,
    queryRank,
    queryUserItem,
    queryCfgItem,
    queryCfgPacket,
    queryUserInfo,
    queryUserExchangeList,
    queryPifu,
    queryBoxList,
    queryBox2List,
    getBox1,
    getBox2,
    getBox4,
    query_09game,
    q_user_record,
    q_my_money
}



// WEBPACK FOOTER //
// ./src/assets/js/s27/controller.js